import React, { Component } from 'react'
import Logo from "../Svgs/Logo"
import LogoEng from "../Svgs/LogoEng"
import './Navigation.css'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { openPolicySearchModal } from "../../actions/policies";
import PolicySearchModal from "../PolicySearchModal/PolicySearchModal";
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import classnames from 'classnames';
import { languageUrls } from "../languageUrls";

class Navigation extends Component {
    state = {
        items: [
            {
                name: 'termsandconditions',
                link: 'termsandconditionsUrl'
            },
            {
                name: 'salespoints',
                link: 'salespointsUrl'
            },
            {
                name: 'aboutus',
                link: 'aboutusUrl'
            },
            {
                name: 'faq',
                link: 'faqUrl'
            },
            {
                name: 'contacts',
                link: 'contactusUrl'
            }
        ],
        active: '',
        currentLanguage: ''
    }







    handleMenuActive = (e) => {
        if (e.target.parentNode.id === "home") {
            localStorage.setItem('menuItem', '');
        }
        else {
            console.log(e.target.parentNode.id)
            localStorage.setItem('menuItem', e.target.parentNode.id);
        }
        // languageUrls
    }

    componentWillMount() {
        localStorage.setItem('menuItem', window.location.pathname);
    }

    // componentDidUpdate(prevProps, prevState) {
    //     if (prevProps.currentLanguage !== this.props.currentLanguage) {
    //         this.setState({
    //             currentLanguage: this.props.currentLocale
    //         })
    //         console.log(this.props.currentLocale, 'cwrp');
    //     }
    // }

    render() {
        const { translate, currentLocale } = this.props
        return (
            <nav className="nav" id="nav">
                <div className="logo" onClick={this.handleMenuActive}>
                    <div id="main-logo">
                        <Link to={"/" + this.props.currentLocale.code} >
                            {
                                localStorage.getItem("currentLanguage") &&
                                    localStorage.getItem("currentLanguage") === "ka" ?
                                    <Logo width={150} /> :
                                    <LogoEng width={150} />
                            }
                        </Link>
                    </div>
                </div>
                {/* <ul className="nav-items">
                    <li onClick={this.handleMenuActive} id="rulesAndConditions" className="nav-item"><Link to="/#"> {translate('rulesAndConditions')}</Link></li>
                    <li onClick={this.handleMenuActive} id="salesPoints" className="nav-item"><Link to="/salePoints"> {translate('salesPoints')}</Link></li>
                    <li onClick={this.handleMenuActive} id="ourInfo" className="nav-item"><Link to="/#"> {translate('ourInfo')}</Link></li>
                    <li onClick={this.handleMenuActive} id="FAQ" className="nav-item"><Link to="/#"> {translate('FAQ')}</Link></li>
                    <li onClick={this.handleMenuActive} id="contacts" className="nav-item"><Link to="/#"> {translate('contacts')}</Link></li>
                </ul> */}
                <ul className="nav-items">
                    {
                        this.state.items.map((item, index) => {
                            return <li key={index}
                                onClick={this.handleMenuActive}
                                id={item.name}
                                className={classnames("nav-item", { 'active-nav-item': localStorage.getItem("menuItem") === "/" + currentLocale.code + "/" + translate(item.link) })}>
                                <Link to={"/" + currentLocale.code + "/" + translate(item.link)}> {translate(item.name)}</Link>
                            </li>
                        })
                    }

                    {/* <span className={classnames('category-item-type', {
                       'category-item-type-selected': name === selectedCar,
               })}>{translate(name)}</span> */}

                </ul>

                <div id="Mobilelanguage">
                    <div className="header-items dropdown" >
                        <LanguageSwitcher />
                    </div>
                </div>
                <PolicySearchModal />
                <div>
                    <button className="search-policy-btn" onClick={() => { this.props.dispatch(openPolicySearchModal(true)) }}>{translate('searchYourPolicy')}</button>
                </div>
            </nav >
        )
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
    currentLocale: getActiveLanguage(state.locale),
});
export default connect(mapStateToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js